import { useCallback } from 'react';
import { useIntl, type MessageDescriptor } from '@atlassian/jira-intl';

export const useExplicitPermissionsSkillPrompt = (): {
	formatExplicitPermissionsSkillPrompt: (message: MessageDescriptor) => string;
} => {
	const { formatMessage } = useIntl();

	const formatExplicitPermissionsSkillPrompt = useCallback(
		(message: MessageDescriptor): string => {
			return `/manage-jira-permissions ${formatMessage(message)}`;
		},
		[formatMessage],
	);

	return { formatExplicitPermissionsSkillPrompt };
};
